<div class="dcf-wrapper dcf-mb-8">

  <!-- Shown when data is loading upon initial page load -->
  @if (token === null) {
    <div>
      <p>We are checking our records, please wait.</p>
    </div>
  }

  <!-- Shown when the token is invalid or does not exist -->
  @if (tokenExists === false) {
    <div >
      <a href="/">You appear to have reached this page in error. Please click here to go to the main page.</a>
    </div>
  }

  <!-- Shown when the token is valid and exists -->
  @if (tokenExists === true) {
    <div >
      <!-- Shown when the appointment is not allowed to be rescheduled/cancelled for any reason -->
      @if (!validForReschedule) {
        <div>
          <p>Your appointment cannot be cancelled or rescheduled.</p>
          <div>
            <p class="dcf-txt-lg"><b>Reason:</b> {{invalidForRescheduleReason}}</p>
          </div>
          <p>If you believe this is a mistake, please call {{phoneNumberToCall}} to speak with a VITA volunteer.</p>
        </div>
      }
      <!-- Shown when the client information is not yet validated -->
      @if (validForReschedule && clientInformationValidated === false) {
        <div>
          <br />
          <p>For security reasons, you must verify the information associated with your appointment</p>
          
          <!-- Form to validate client information -->
          <form
            #validationForm="ngForm"
            class="cmxform dcf-form"
            id="validateClientInformationForm"
            name="form"
            (ngSubmit)="validationForm.valid && validateClientInformation()"
            autocomplete="off"
            novalidate>
            <ul class="dcf-list-bare">
              <li class="dcf-form-group form-textfield">
                <label class="dcf-label form-label form-required" for="firstName">First Name</label>
                <input class="dcf-input-text" type="text" name="firstName" id="firstName" [(ngModel)]="clientData.firstName" required>
                <div ng-show="form.$submitted || form.firstName.$touched">
                  <label class="error" ng-show="form.firstName.$error.required">This field is required.</label>
                </div>
              </li>
              <li class="dcf-form-group form-textfield">
                <label class="dcf-label form-label form-required" for="lastName">Last Name</label>
                <input class="dcf-input-text" type="text" name="lastName" id="lastName" [(ngModel)]="clientData.lastName" required>
                <div ng-show="form.$submitted || form.lastName.$touched">
                  <label class="error" ng-show="form.lastName.$error.required">This field is required.</label>
                </div>
              </li>
              <li class="dcf-form-group form-textfield">
                <label class="dcf-label form-label" for="email">Email</label>
                <input class="dcf-input-text" type="email" name="email" id="email" [(ngModel)]="clientData.email">
                <p class="dcf-txt-xs">If you provided an email while signing up, this field is required to verify your information.</p>
              </li>
              <li class="dcf-form-group form-textfield">
                <label class="dcf-label form-label form-required" for="phone">Phone Number</label>
                <input class="dcf-input-text" type="text" name="phone" id="phone" [(ngModel)]="clientData.phone" required>
                <div ng-show="form.$submitted || form.phone.$touched">
                  <label class="error" ng-show="form.phone.$error.required">This field is required.</label>
                </div>
              </li>
            </ul>
            <input type="submit"
              value="Submit"
              class="submit dcf-btn dcf-btn-primary"
              [disabled]="!validationForm.valid">
          </form>
          @if (invalidClientInformation === true) {
            <p class="error" style="color: #d00001; margin-top: 1rem">
              The information you provided did not match our records. Please try again.
            </p>
          }
        </div>
      }
      <!-- Shown once the client information has been validated -->
      @if (clientInformationValidated === true) {
        <div>
          @if (!rescheduleSuccessMessage && appointmentCancelled === false) {
            <div>
              <p>Thank you for verifying your information. You may now cancel or reschedule your appointment below.</p>
              <!-- Current Appointment Information -->
              <h4 class="clear-top">Current Appointment Information</h4>
              <div>
                <div>
                  <p class="clear-vertical"><b>Name:</b> {{clientData.firstName}} {{clientData.lastName}}</p>
                </div>
                <div>
                  <p class="clear-vertical"><b>Site:</b> {{currentAppointment?.site?.title}}</p>
                </div>
                <div>
                  <p class="clear-vertical"><b>Site Address:</b> {{currentAppointment?.site?.address}}</p>
                </div>
                <div>
                  <p class="clear-top"><b>Time:</b> {{currentAppointment?.scheduledTime}}</p>
                </div>
                <!-- Cancel Button -->
                <a id="confirm-cancel-modal-opener"
                  class="submit dcf-btn dcf-btn-secondary"
                  (click)="openCancelling()"
                skipLocationChange>Cancel Appointment</a>
              </div>
              <!-- Horizontal separator -->
              <div class="horizontal-line"></div>
              <br />
              <br />
              <!-- Reschedule Section -->
              <h4 class="clear-top">Reschedule Appointment</h4>
              <form
                #rescheduleForm="ngForm"
                class="cmxform dcf-form" id="rescheduleForm">
                <app-appointment-picker
                  appointmentType="residential"
                  [city]="city"
                ></app-appointment-picker>
                <!-- Reschedule button -->
                <br />
                <br />
                <input type="submit"
                  value="Reschedule"
                  id="rescheduleButton"
                  name="rescheduleButton"
                  class="submit dcf-btn dcf-btn-primary"
                  [disabled]="!nullSettings() || submittingReschedule"
                  (click)="rescheduleAppointment()">
              </form>
            </div>
          }
          <!-- Successful Reschedule Screen -->
          @if (rescheduleSuccessMessage != null) {
            <div>
              <div [innerHtml]="rescheduleSuccessMessage"></div>
              <div class="dcf-mt-3">
                <button type="button" class="dcf-btn dcf-btn-primary" onclick="window.print();">Print</button>
                @if (clientData.email != null) {
                  <button type="button"
                    class="dcf-btn dcf-btn-primary email-confirmation-button"
                    [disabled]="emailButton.disabled"
                  (click)="emailConfirmation()">{{emailButton.text}}</button>
                }
              </div>
            </div>
          }
          <!-- Successful Cancelling Screen -->
          @if (appointmentCancelled === true) {
            <div>
              <p>Your appointment has been cancelled.</p>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
